
import {
    GET_INVOICE_COLUMNSVALUES_REQUEST, GET_INVOICE_COLUMNSVALUES_SUCCESS, GET_INVOICE_COLUMNSVALUES_ERROR
} from "../actions/types";
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_INVOICE_COLUMNSVALUES_REQUEST:
            return {
                loading: true,
            };
        case GET_INVOICE_COLUMNSVALUES_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_INVOICE_COLUMNSVALUES_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}

